import React from 'react'

export default function withDeviceHeightResize(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props)

      this.state = {
        height: this.getDeviceHeight()
      }
    }

    componentDidMount() {
      window.addEventListener("setDeviceHeight", this.setHeight)
      !this.isEmbedded() && window.addEventListener("resize", this.setHeight)
    }

    componentWillUnmount() {
      window.removeEventListener("setDeviceHeight", this.setHeight)
      !this.isEmbedded() && window.removeEventListener("resize", this.setHeight)
    }

    isEmbedded = () => !!window.__deviceHeight__

    getDeviceHeight = () => {
      return window.__deviceHeight__ || window.innerHeight // window.__deviceHeight__ is set in EmbeddedBoardContainer
    }

    setHeight = (e) => {
      const height = this.getDeviceHeight()
      if(height == this.state.height) {
          return
      }

      this.setState({ height })
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          deviceHeight={this.state.height} />
        )
    }
  }
}

